// Station observations on the map: the readings valid at the timeline hour.
// Only the first few forecast hours are observed; past them the last
// observed hour stays on the map.

function validIso(reference, hour) {
  return new Date(new Date(reference).getTime() + hour * 3600_000).toISOString().slice(0, 19) + "Z";
}

export function observationsAt(fc, manifest, hour) {
  if (!fc || !manifest) return [];
  const times = [...new Set(fc.features.map((f) => f.properties.observed_at))].sort();
  if (!times.length) return [];
  const want = validIso(manifest.reference_time, hour);
  const at = times.includes(want) ? want : times.filter((t) => t <= want).pop() || times[0];
  return fc.features.filter((f) => f.properties.observed_at === at);
}

const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);

export function stationTooltip(p) {
  return `<b>${esc(p.station_id)}</b> · ${esc(p.station_name)}<br/>${esc(p.raw_metar || "")}`;
}
